import { ApiError } from "./common.schemas";
export class ValidationError extends ApiError {
    constructor(message, zodError) {
        super(message, 400, "VALIDATION_ERROR", {
            issues: zodError.issues,
            formErrors: zodError.formErrors,
        });
        this.name = "ValidationError";
        this.zodError = zodError;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ValidationError);
        }
    }
    get formattedErrors() {
        return this.zodError.issues.map((issue) => `${issue.path.join(".")}: ${issue.message}`).join("; ");
    }
}
export class PopulateError extends ApiError {
    constructor(field, context, availableFields = []) {
        const suggestion = availableFields.length > 0 ? ` Available fields: ${availableFields.slice(0, 10).join(", ")}` : "";
        super(`Populated field "${field}" is missing from response in ${context}.${suggestion}`, 500, "POPULATE_ERROR", {
            field,
            context,
            availableFields,
        });
        this.name = "PopulateError";
        this.field = field;
        this.context = context;
        this.availableFields = availableFields;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PopulateError);
        }
    }
}
export class FilterValidationError extends ApiError {
    constructor(invalidFields, validFields, context) {
        super(`Invalid filter fields in ${context}: ${invalidFields.join(", ")}. ` +
            `Valid fields: ${validFields.slice(0, 15).join(", ")}`, 400, "FILTER_VALIDATION_ERROR", { invalidFields, validFields });
        this.name = "FilterValidationError";
        this.invalidFields = invalidFields;
        this.validFields = validFields;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FilterValidationError);
        }
    }
}
export function formatZodErrors(error) {
    return error.issues
        .map((issue) => {
        const path = issue.path.length > 0 ? `${issue.path.join(".")}: ` : "";
        return `${path}${issue.message}`;
    })
        .join("; ");
}
export function validateResponse(schema, data, options) {
    const { context = "unknown", populate, strict = true } = options ?? {};
    const result = schema.safeParse(data);
    if (!result.success) {
        const msg = `Response validation failed in ${context}: ${formatZodErrors(result.error)}`;
        if (strict) {
            throw new ValidationError(msg, result.error);
        }
        console.warn("[api-client]", msg);
        return data;
    }
    if (populate && populate.length > 0) {
        const dataObj = result.data;
        for (const field of populate) {
            const topField = field.split(".")[0];
            if (!(topField in dataObj)) {
                const msg = `Populated field "${topField}" is missing from response in ${context}`;
                if (strict) {
                    throw new PopulateError(topField, context);
                }
                console.warn("[api-client]", msg);
            }
        }
    }
    return result.data;
}
export function validateInput(schema, input, context) {
    const result = schema.safeParse(input);
    if (!result.success) {
        const formattedErrors = formatZodErrors(result.error);
        throw new ValidationError(`Validation failed in ${context}: ${formattedErrors}`, result.error);
    }
    return result.data;
}
export function validateInputSafe(schema, input) {
    return schema.safeParse(input);
}
